import React from 'react';
import PropTypes from 'prop-types';
import { HiDocumentAdd } from 'react-icons/hi';
import Button from 'partial/components/Button';
import SectionHeader from 'partial/components/SectionHeader';
import GridCms from './GridCms';

const useCmsList = () => {
  const [list] = React.useState([
    {
      id: 1,
      label: 'Pay your bills anytime',
      photo_url: 'https://ucarecdn.com/6b449cbc-90c3-49c2-85f2-2b9116c98b01/',
      description:
        'Your all-in-one application you need to drive your daily needs.',
      url: 'https://www.contis.ph',
      type: 'Web Url',
    },
    {
      id: 2,
      label: 'Send money real-time',
      photo_url: 'https://ucarecdn.com/e1ebd3dd-971d-4c03-8603-e27aefda6ccb/',
      description: 'Send money real-time using this app.',
      type: 'Send Money',
    },
    {
      id: 3,
      label: 'Load wallet anywhere',
      photo_url: 'https://ucarecdn.com/6ab8fc34-46fe-4ebe-ae89-cb5d6d5f37c5/',
      description: 'You can buy your load in just few step. Try it now.',
      type: 'Buy Load',
    },
  ]);
  return [false, list];
};

function SliderCms({ data, onSelect }) {
  const [isLoading, list] = useCmsList();
  const handleAdd = () => {
    console.log('handle add'); // eslint-disable-line
  };
  const handleSelect = (row) => {
    onSelect(row);
  };
  return (
    <>
      <div className="px-4 pt-5">
        <SectionHeader label={data.label}>
          <Button
            primary
            icon={HiDocumentAdd}
            onClick={handleAdd}
            disabled={isLoading}
          >
            Add
          </Button>
        </SectionHeader>
      </div>
      <div className="p-6">
        <GridCms
          isLoading={isLoading}
          data={list}
          labelKey="label"
          photoKey="photo_url"
          subKey="type"
          onSelect={handleSelect}
          onAdd={handleAdd}
        />
      </div>
    </>
  );
}

SliderCms.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default SliderCms;
